import { useEffect, useState } from "react";
import Box from "elements/Box";
import { Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AlertDialog from "elements/AlertDialog";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";
import RegionsEditor from "./RegionsEditor";

import "assets/css/main.css";

export default function RegionsList(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading } = props;

  const [list, setList] = useState<any[]>([]);
  const [openEditor, setOpenEditor] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    loadList();
  }, []);

  const loadList = async () => {
    setLoading(true);
    await ApiRequest({
      url: "/locationRegions/list",
      method: "get",
      headers: { ltkn: localStorage.getItem("ltkn") },
      query: { full_list: true },
      setResponse: (response: any) => {
        setList(response.list);
        setLoading(false);
      },
    });
  };

  const handleDelete = (id: number) => {
    setActiveItem(id);
    setOpenAlert(true);
  };

  const deleteItem = async () => {
    await ApiRequest({
      url: "/locationRegions/delete",
      method: "post",
      headers: { ltkn: localStorage.getItem("ltkn") },
      body: { id: activeItem },
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Región eliminada con éxito", { variant: "success" });
          loadList();
        }
        setOpenAlert(false);
      },
    });
  };

  return (
    <div id="RegionsList" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Regiones</h2>
            <span className="h2_subtitle">Lista de Regiones</span>
          </div>
          <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => { setActiveItem(null); setOpenEditor(true); }}
              startIcon={<AddIcon />}
            >
              Crear Región
            </Button>
          </div>
        </div>

        <Box id="RegionsListIn" className="box100">
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>CÓDIGO DANE</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>REGIÓN</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.dane_code}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        startIcon={<ModeEditIcon />}
                        onClick={() => { setActiveItem(item.id); setOpenEditor(true); }}
                      >
                        Editar
                      </Button>
                      <IconButton size="small" onClick={() => handleDelete(item.id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <RegionsEditor
          openEditor={openEditor}
          setOpenEditor={setOpenEditor}
          region_id={activeItem}
          loadList={loadList}
          setLoading={setLoading}
        />

        <AlertDialog
          open={openAlert}
          setOpen={setOpenAlert}
          subtitle="¿Estás seguro de que deseas eliminar esta región?"
          send={deleteItem}
        />
      </div>
    </div>
  );
}
